
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { BASE_URL } from '../static/constant';
import { message } from 'antd'
export default function getApolloClient(query, variables, mutation) {
    if (mutation == null) {
      return Promise.race([request(query, variables), defineTimeout(10 * 1000)]).catch(err => {
        console.log('获取失败！' + err);
        message.error('Network timeout, please try again.')
      })
    } else {
      return Promise.race([up(mutation, variables), defineTimeout(10 * 1000)]).catch(err => {
        console.log('请求失败！' + err);
        message.error('Network timeout, please try again')
      })
    }



}
/**
 * 发送请求
 * @param {*} query 
 * @param {*} variables 
 * @returns 
 */
function request(query, variables) {
  return new Promise((resolve, reject) => {
    new ApolloClient({
      cache: new InMemoryCache(),
      uri: BASE_URL,
    }).query({
      query: query,
      variables: variables
    }).then((res) => {
      console.log("then:", res)
      resolve(res)
    }).catch(e => {
      reject(e)
    });
  })
}
/**
 * 上传
 * @param {*} mutation 
 * @param {*} variables 
 * @returns 
 */
function up(mutation, variables) {
  return new Promise((resolve, reject) => {
    new ApolloClient({
      cache: new InMemoryCache(),
      uri: BASE_URL,
      headers: { authorization: GetToken() },
    }).mutate({
      mutation: mutation,
      variables: variables
    }).then((res) => {
      console.log("then:", res)
      resolve(res)
    }).catch(e => {
      reject(e)
    });
  })
}
/**
 * 
 * @returns 获取token
 */
function GetToken() {
  const token = sessionStorage.getItem("sessionToken")
  if (token === '') {
    return '';
  } else {
    return token;
  }
}

/**
 * 超时
 * @param {超时时常} time 
 * @returns 
 */
function defineTimeout(time) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject("请求超时！");
    }, time);
  });
}